import React, { Component } from 'react'
import { connect } from 'react-redux';
import './style.scss'
import { Button, Card, CardBody, Col, Label, Row } from 'reactstrap';
import Select from 'react-select';
import MultiSelect from '../../components/ReusableComponents/MultiSelect';
import { Preloading } from '../../components/UI/Preloader/action';
import{listCorporate, getAnalystsList, userSelectedCorporates, fetchUserCorporates} from "./action";


class UserAccessManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            analystUserList: [],
            corporateList: [],
            selectedAnalystUserList: [],
            selectedCorporateList: [],
            selectedUser: {},
            fetchCorporates: {},
            corporateListUnTouched: [],
        }
    }

    componentDidMount(){
        this.props.preloading(true);
        this.props.getAnalystsUserList();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.corporateList !== this.props.corporateList) {
            this.props.preloading(false);
            this.setState({
                corporateListUnTouched: this.props.corporateList
            });
        }

        if(prevProps.analystUsersList !== this.props.analystUsersList) {
            this.props.preloading(false);
            let constructedArr = [];
            this.props.analystUsersList && this.props.analystUsersList.forEach(elm=> {
                constructedArr.push({label : elm.firstname + " " + elm.lastname, value : elm})
            });
            this.setState({
                analystUserList : constructedArr
            });
            this.props.preloading(true);
            this.props.getListCorporate();
        }

        if(prevProps.fetchCorporates !== this.props.fetchCorporates){
            this.props.preloading(false);
            let constructedArr = [];
            this.props.corporateList.length && this.props.corporateList.forEach(elm=>{
                let accesibleCorps = this.props.fetchCorporates.data && this.props.fetchCorporates.data.corporates && this.props.fetchCorporates.data.corporates.length ? this.props.fetchCorporates.data.corporates.map(item=>item.corporateId) : [];
                !accesibleCorps.includes(elm.id) && constructedArr.push({ label: elm.name, value: elm });
            })
        
            this.setState({
                corporateList: constructedArr,
                fetchCorporates: this.props.fetchCorporates.data
            });
        }

        if(prevProps.selectedCorporates !== this.props.selectedCorporates){
            this.props.preloading(false);
            this.props.preloading(true);
            this.setState({selectedCorporateList: []})
            this.props.fetchingUserCorporates(this.state.selectedUser.value.id);

        }

        if(prevProps.fetchCorporatesError !== this.props.fetchCorporatesError){
            this.props.preloading(false);
            this.setState({selectedCorporateList: []});
            toast.error(
                <div style={{ wordBreak: 'break-all' }}>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{'Something went wrong, Please try again later!'}
                </div>
            );
        }

        if(prevProps.selectedCorporatesError !== this.props.selectedCorporatesError){
            this.props.preloading(false);
            toast.error(
                <div style={{ wordBreak: 'break-all' }}>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{'Something went wrong, Please try again later!'}
                </div>
            );
        }

        if(prevProps.corporateListError !== this.props.corporateListError){
            this.props.preloading(false);
            toast.error(
                <div style={{ wordBreak: 'break-all' }}>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{'Something went wrong, Please try again later!'}
                </div>
            );
        }

        if(prevProps.analystsListFailure !== this.props.analystsListFailure){
            this.props.preloading(false);
            toast.error(
                <div style={{ wordBreak: 'break-all' }}>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{'Something went wrong, Please try again later!'}
                </div>
            );
        }
    }

    selectedEntityCallback = (selectedData) => {
        this.setState({
            selectedCorporateList: selectedData
        })
    }

    handleAnalystUserChange = (user) => {
        this.setState({
            selectedUser: user,
            selectedCorporateList: []
        });
        this.props.preloading(true);
        this.props.fetchingUserCorporates(user.value.id);
    }

    handleSubmitBtn = () => {
        let selCorpList = this.state.selectedCorporateList.map(corp=>{
            return({"corporateId":corp.value.id, "corporateName":corp.value.name})
        });
        let selCorpConcatAccesibleCorps = this.state.fetchCorporates && this.state.fetchCorporates.corporates && this.state.fetchCorporates.corporates.length ? this.state.fetchCorporates.corporates.concat(selCorpList) : selCorpList;
         let payload = {
            "userId": this.state.selectedUser.value.id,
            "username": this.state.selectedUser.value.username,
            "corporates":  selCorpConcatAccesibleCorps
        }
        this.props.preloading(true);
        this.props.postUserSelectedCorporates(payload)
    }

    handleCloseIcon = (targetCorp) => {
        let filteredCorps = this.state.fetchCorporates.corporates.filter(item=>item.corporateId !== targetCorp.corporateId);
        let corpsList = this.state.corporateList;
        corpsList.unshift({label:targetCorp.corporateName, value:{id:targetCorp.corporateId , name: targetCorp.corporateName}});
        this.setState({fetchCorporates:{...this.state.fetchCorporates,corporates:filteredCorps}, corporateList: corpsList});
     }

    render() { 
        return ( 
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="userAccessManagementTitle mb-0 text-center">User Access Management</h4>
                </div>
                <Card>
                    <CardBody>
                        <Row>
                            <Col sm={12}>
                                <Label>Select User</Label>
                                <Row>
                                    <Col sm={16}>
                                    <Select
                                        onChange={this.handleAnalystUserChange}
                                        options={this.state.analystUserList}
                                        isClearable={false}
                                        required/>
                                    </Col>
                                </Row>
                                <Label>Select Corporates</Label>
                                <Row>
                                    <Col sm={20}>
                                    <MultiSelect 
                                        data={this.state.corporateList}
                                        selected={this.selectedEntityCallback}
                                        selectedValue={this.state.selectedCorporateList}
                                        isDisabled={!Object.entries(this.state.selectedUser).length}/>
                                    </Col>
                                </Row>
                                <CardBody>
                                    <Row>
                                        <Col sm={16} className='submitBtn'>
                                        <Button color='primary' onClick={()=>this.handleSubmitBtn()}>
                                            Submit
                                        </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Col>
                            <Col sm={12}>
                                {this.state.fetchCorporates && this.state.fetchCorporates.corporates && this.state.fetchCorporates.corporates.length>0 && <Card className='userCorporatesCard'>
                                <h5 className='accessibleCorporatesTitle'>Accessible Corporates</h5>
                                    <ul className='userCorporatesList' style={{
                                        overflowY: this.state.fetchCorporates.corporates.length > 6 ? 'scroll' : 'auto',
                                        maxHeight: this.state.fetchCorporates.corporates.length > 6 ? '200px' : 'none',}}>
                                        {this.state.fetchCorporates.corporates.map(corp=>{
                                        return(<li key={corp.corporateId}><p>{corp.corporateName}</p><span><button type="button" onClick={()=>this.handleCloseIcon(corp)} className="close" aria-label="Close"  ><span aria-hidden="true">×</span></button></span></li>)
                                        })}
                                    </ul>
                                </Card>}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
         );
    }
}

const mapStateToProps = (state, ownProps) => ({
    analystUsersList : state.userAccessManagementCorporateListData.analystsListSuccess,
    analystsListFailure : state.userAccessManagementCorporateListData.analystsListFailure,
    corporateList : state.userAccessManagementCorporateListData.corporateList,
    corporateListError : state.userAccessManagementCorporateListData.corporateListError,
    selectedCorporates : state.userAccessManagementCorporateListData.selectedCorporates,
    selectedCorporatesError : state.userAccessManagementCorporateListData.selectedCorporatesError,
    fetchCorporates : state.userAccessManagementCorporateListData.fetchCorporates,
    fetchCorporatesError : state.userAccessManagementCorporateListData.fetchCorporatesError
  })
  
  const mapDispatchToProps = (dispatch) => ({
    getAnalystsUserList:()=>{dispatch(getAnalystsList())},
    getListCorporate:()=>{dispatch(listCorporate())},
    postUserSelectedCorporates:(data)=>{dispatch(userSelectedCorporates(data))},
    fetchingUserCorporates:(data)=>{dispatch(fetchUserCorporates(data))},
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
  });

  export default connect(mapStateToProps, mapDispatchToProps)(UserAccessManagement);